module.exports = __webpack_public_path__ + "img/strelica_dupla.3ac968bc.svg";